export const strings = {
    prefixAgo: 'cách đây',
    prefixFromNow: null,
    suffixAgo: null,
    suffixFromNow: 'trước',
    seconds: 'chưa đến 1 phút',
    minute: 'khoảng 1 phút',
    minutes: '%d phút',
    hour: 'khoảng 1 tiếng',
    hours: 'khoảng %d tiếng',
    day: '1 ngày',
    days: '%d ngày',
    month: 'khoảng 1 tháng',
    months: '%d tháng',
    year: 'khoảng 1 năm',
    years: '%d năm',
    wordSeparator: ' ',
};
